<template>
  <div>
    <b-card>
      <template v-if="loading">
        <div class="d-flex justify-content-center bd-highlight mb-3">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </template>
      <template v-else>
        <h4 class="mb-4">
          <strong>Fatura - EC </strong>
        </h4>
        <Form :costcenter="costcenter" class="mt-2"></Form>
      </template>
    </b-card>
  </div>
</template>

<script>
import Form from "./form-invoice";

export default {
  components: {
    Form
  },

  data() {
    return {
      loading: true,
      costcenter: {}
    };
  },
  created() {
    if (this.$route.params.id > 0) {
      this.getCostCenter();
    } else {
      this.loading = false;
    }
  },

  methods: {
    async getCostCenter() {
      await this.$api
        .get(`v1/costcenter/${this.$route.params.id}/`)
        .then(result => {
          this.loading = false;
          if (!result.data.payload) {
            this.$router.push({ path: "/404" });
          }
          this.costcenter = result.data.payload;
        })
        .catch(e => {
          // Surpress
        });
    }
  }
};
</script>
